import { QueryClientProvider } from "@tanstack/react-query";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { createBrowserRouter, RouterProvider } from "react-router";

import { AppProviders } from "@/components/app-providers";
import { createQueryClient } from "@/query-client";
import { routes } from "@/routes";
import { ThemeProvider } from "@/theme";

const queryClient = createQueryClient();
const router = createBrowserRouter(routes);

/** Keeps the page's language attribute in step with the UI language. */
function DocumentLanguage() {
  const { i18n } = useTranslation();
  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);
  return null;
}

export function App() {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <DocumentLanguage />
        <AppProviders>
          <RouterProvider router={router} />
        </AppProviders>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
